import { useEffect, useState } from 'react'

import { ReactTyped } from 'react-typed'

import { socialAppsWorks } from '../common/Helper'
import { Arrow, LineThrough, Sequoia } from '../common/Icons'
import CtaButton from '../custom-ui/CtaButton'
import PrimaryHeading from '../custom-ui/PrimaryHeading'

import VideoPlayer from './VideoPlayer'

const Hero = () => {
  const [isAnimationVisible, setIsAnimationVisible] = useState(false)
  const [isLineVisible, setIsIsLineVisible] = useState(false)
  const [textColor, setTextColor] = useState(false)
  useEffect(() => {
    // Set a timeout to add the class after 3 seconds (3000 milliseconds)
    const timeoutId = setTimeout(() => {
      setIsAnimationVisible(true)
    }, 1900)

    // Set a timeout to add the class after 5 seconds (5000 milliseconds) for the second div
    const timeoutId2 = setTimeout(() => {
      setIsIsLineVisible(true)
    }, 1500)
    // Set a timeout to add the class after 5 seconds (5000 milliseconds) for the second div
    const timeoutId3 = setTimeout(() => {
      setTextColor(true)
    }, 1300)
    // Clean up the timeouts to avoid memory leaks
    return () => {
      clearTimeout(timeoutId)
      clearTimeout(timeoutId2)
      clearTimeout(timeoutId3)
    }
  }, []) // This effect runs only once when the component mounts
  return (
    <section className="overflow-hidden pb-12 pt-24">
      <div className="custom_container container flex flex-col items-center justify-center">
        <PrimaryHeading class="!md:leading-116 grid h-[clamp(150px,36.7278797997vw,220px)] !text-[clamp(48px,11.6888vw,72px)] !font-semibold !leading-100 tracking-[-2.16px] sm:h-auto sm:min-h-[220px] md:min-h-0 md:scale-90 lg:scale-100">
          <span className="items-top relative flex max-h-[90px] flex-col justify-between md:flex-row md:justify-center ">
            <span
              className={` relative px-2 text-blue duration-500 ${
                textColor ? 'text-gray' : ''
              }`}
            >
              <ReactTyped
                showCursor={false}
                strings={['Artificial']}
                typeSpeed={80}
              />
              <span
                className={`absolute -left-2 top-1/2 -translate-y-1/2 duration-500 max-[600px]:left-1/2 max-[600px]:w-[80%] max-[600px]:-translate-x-1/2 ${
                  isLineVisible ? 'w-full' : 'w-0'
                }`}
              >
                <LineThrough />
              </span>
            </span>
            <span
              className={`mt-1 hidden opacity-0 duration-1000 md:block ${
                isAnimationVisible ? '!opacity-100' : ''
              }`}
            >
              <Arrow />
            </span>
            <span className="customer_text -top-full font-caveat !text-[clamp(48px,11.6888vw,72px)] text-blue md:absolute">
              <ReactTyped
                showCursor={false}
                strings={['Customer']}
                typeSpeed={90}
                startDelay={2200}
              />
            </span>
            Intelligence
          </span>
        </PrimaryHeading>
        <p className="mt-3 text-center text-xl font-semibold leading-[109%] tracking-[-0.96px] text-night-black sm:text-[32px]">
          AI-native CRM that brings customers into every decision
        </p>
        <div className="my-12">
          <p className="text-center text-base font-medium  tracking-md text-night-black opacity-70">
            Works seamlessly with:
          </p>
          <div className="flex items-center justify-center gap-2 sm:gap-3">
            {socialAppsWorks.map((obj, index) => {
              return (
                <div
                  key={index}
                  className="relative"
                >
                  {obj.icon}
                  {index === socialAppsWorks.length - 1 && (
                    <span className="absolute bottom-1 left-1/2 inline-flex h-[19px] -translate-x-1/2 items-center whitespace-nowrap rounded-full border border-night-black border-opacity-20 bg-white px-2 text-[10px] font-medium tracking-md shadow-[4px_4px_20px_0px_#0000001A]">
                      coming soon
                    </span>
                  )}
                </div>
              )
            })}
          </div>
        </div>
        <CtaButton
          title="Get early access"
          url="https://get.day.ai/get-early-access/"
        />
        <p className="common-pera mt-3">
          Join the waitlist to receive early access to Day.ai
        </p>

        <p className="common-pera my-12 flex gap-3 !text-base">
          Backed by <Sequoia />
        </p>
        <VideoPlayer />
      </div>
    </section>
  )
}

export default Hero
